<template>
  <div class="home">
    <section class="hero is-halfheight is-bold">
      <div class="hero-body">
        <div class="container">
          <h1>{{ $t('404-title') }}</h1>
          <h2 class="subtitle">{{ $t('404-subtitle') }}</h2>
          <div>
            <router-link v-if="loginState.user" class="button is-primary is-medium" to="/dashboard">
              {{ $t('Continue to Your Dashboard') }}
            </router-link>
            <router-link v-else class="button is-primary is-medium" to="/login">
              {{ $t('getStarted') }}
            </router-link>
            <p v-if="secondsLeft > 0" class="mt-3">Redirecting in {{ secondsLeft }}s</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script lang="ts">
import { mapState } from 'vuex';
import Vue from 'vue';
import Component from 'vue-class-component';
import { LoginState } from '@/store/store';

const REDIRECT_AFTER_SECONDS = 30;

@Component({
  props: {
    redirectedFrom: {
      type: String,
    },
  },
  computed: {
    ...mapState(['loginState']),
  },
})
export default class PageNotFound extends Vue {
  // store state refs
  protected loginState!: LoginState;
  protected redirectedFrom!: string | undefined;
  protected secondsLeft: number = REDIRECT_AFTER_SECONDS;
  protected timer: number | null = null;

  protected mounted(): void {
    let requestedPage = '?';
    if (this.redirectedFrom !== undefined) {
      requestedPage = this.redirectedFrom;
    }
    this.startCountdown();
    throw new Error('Page Not Found: [' + requestedPage + ']');
  }

  protected beforeDestroy(): void {
    if (this.timer !== null) {
      window.clearInterval(this.timer);
    }
  }

  protected startCountdown(): void {
    this.timer = window.setInterval(() => {
      this.secondsLeft--;
      if (this.secondsLeft > 0) {
        return;
      }
      void this.$router.push(this.loginState.user ? '/dashboard' : '/login');
    }, 1000);
  }
}
</script>

<style lang="scss" scoped>
.home {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
</style>
